var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{attrs:{"size":"small"},model:{value:(_vm.chooseTypeData),callback:function ($$v) {_vm.chooseTypeData=$$v},expression:"chooseTypeData"}},_vm._l((_vm.chooseOptions),function(item,index){return _c('el-radio-button',{key:index,attrs:{"label":item.label}},[_vm._v(_vm._s(item.value))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }